import { convertCentToDollar } from "../utils/numbers";

const convertArrayOfObjectsToCSV = (array, columns) => {
    let result;
    const columnDelimiter = ',';
    const lineDelimiter = '\n';

    result = '';
    result += columns.map(column => column.name).join(columnDelimiter);
    result += lineDelimiter;
    array.forEach((item) => {
        let ctr = 0;
        columns.forEach((column) => {
            const {selector, type} = column;
            if (ctr > 0) result += columnDelimiter;
            let value = (typeof selector == 'function') ? selector(item) : item[selector];
            let rawVal = (type === "currency") ? convertCentToDollar(value) : value;
            let val = rawVal ? String(rawVal) : '';
            if (val.indexOf(',') > -1) {
                val = `\"${val}\"`;
            }
            result += val;
            ctr++;
        });
        result += lineDelimiter;
    });
    return encodeURIComponent(result);
};

export const downloadCSV = (array, configs, csvFileName) => {
    if (typeof window !== "undefined") {
        const {columns} = configs;
        const link = document.createElement('a');
        let csv = convertArrayOfObjectsToCSV(array, columns);
        if (csv == null) return;

        const filename = `${csvFileName}.csv`;

        if (!csv.match(/^data:text\/csv/i)) {
            csv = `data:text/csv;charset=utf-8,${csv}`;
        }

        link.setAttribute('href', csv);
        link.setAttribute('download', filename);
        link.click();
    }
};

export const downloadBlobAsCsvFile = (blob, filename) => {
    const blobUrl = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.setAttribute('href', blobUrl);
    link.setAttribute('download', filename);
    link.click();
};